function docReady(fn) {
  if (document.readyState === "complete" || document.readyState === "interactive") {
      setTimeout(fn, 1);
  } else {
      document.addEventListener("DOMContentLoaded", fn);
  }
}

docReady(function(){
  Array.from(document.querySelectorAll(".flag-link")).forEach(el => {
    let parentElement = el;
    let flag =  new CountryFlag(el);
    let isoCountry = el.getAttribute("data-value");
    flag.selectByAlpha2(isoCountry);
    flag.element.style.display = "block";
  });

  
  if (isIOS()) {
  document.querySelector("body").classList.add('mobile--iOS')
  const flagContainer = document.getElementById('fls-Country__list');
  if (flagContainer) {
    new SimpleBar(flagContainer,{ autoHide: false });
  }
  }
})

const isIOS = () => {
  const ua = navigator.userAgent
  return (/iPad|iPhone|iPod/.test(ua)) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)    
}